import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, prjName, prjNo, subTypeCode, sVer} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => openWindow(
        '/Ai',

        {
            bizMap: {prjs: [{prjId, prjName, prjNo, sVer}]},
            prjId,
            scene: 'GENERATE_AIS',
            sVer,
        }
    )

    return {
        label: '变更范围分析',
        onClick,
    }
}
